import { useEffect, useMemo, useRef } from 'react'
import { HtmlContentProps } from './HtmlContent.types'
import { SectionContainer } from '../../components/SectionContainer'

export const HtmlContent = ({
  contentId,
  content,
  css,
  javascript,
  width,
  isPageSection = true,
}: HtmlContentProps) => {
  const containerRef = useRef<HTMLElement | null>(null)

  const setContainerRef = (element: HTMLElement | null) => {
    containerRef.current = element
  }

  const htmlContent = useMemo(() => {
    return `${css || ''}${content || ''}`
  }, [content, css])

  useEffect(() => {
    if (!javascript || !containerRef.current) {
      return
    }

    const scriptId = `htmlContentScript-${contentId}`

    if (document.getElementById(scriptId)) {
      return
    }

    const scriptEl = document.createElement('script')
    scriptEl.id = scriptId
    scriptEl.textContent = javascript.replace(/<\/?script>/gi, '')

    containerRef.current.appendChild(scriptEl)
  }, [contentId, javascript])

  const Container = isPageSection ? 'section' : 'div'

  const containerElement = (
    <Container
      ref={setContainerRef}
      id={contentId}
      dangerouslySetInnerHTML={{
        __html: htmlContent,
      }}
    />
  )

  if (!isPageSection) {
    return containerElement
  }

  return <SectionContainer width={width}>{containerElement}</SectionContainer>
}
